import { DataTable } from './../../interfaces/datatable.interface';
import { Component, OnInit, Input, HostListener } from '@angular/core';

@Component({
  selector: 'app-datatable-mostrar-columnas',
  templateUrl: './datatable-mostrar-columnas.component.html',
  styleUrls: ['./datatable-mostrar-columnas.component.scss']
})
export class DatatableMostrarColumnasComponent implements OnInit {

  @Input() id: string;
  @Input() datatable: DataTable;

  MAX_VALUES = 12;
  MAX_VALUES_THREE_COL = 30;

  HALF = 1;

  MAX_WIDTH = 450;
  innerWidth: number;
  // Max values solo aplica si no es celular | innerWidth

  constructor() { }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.HALF = Math.round(this.datatable.columnas.length / 2);

    this.datatable.columnas = this.datatable.columnas.map(c => {
      c.mostrar = c.mostrar !== false;
      return c;
    });
  }

  counter(i: number) {
    return new Array(i);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

}
